import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import { getUrlParam } from '../../utils/general';
import { INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK } from '../../constants/analytics';
import { track } from '../../analytics/analytics';
import { TAlertType } from '../../models/common/alert';
import { useInstantCheckoutStatus } from '../../hooks/use-instant-checkout-status';

export const InstantCheckoutAlert = () => {
  const { alertMessage, setAlertMessage } = useInstantCheckoutStatus();
  const isUpdateMessage =
    alertMessage?.alertType === TAlertType.IC_ADDRESS_UPDATE ||
    alertMessage?.alertType === TAlertType.IC_PAYMENT_UPDATE;

  const setContinueShoppingAnalytics = () => {
    const successType =
      alertMessage?.alertType === TAlertType.IC_ADDRESS_UPDATE
        ? 'delivery address'
        : 'payment method';

    track(INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK, successType);
  };

  const icReferrer = getUrlParam('icReferrer');
  const referrerUrl =
    icReferrer && new URL(icReferrer, window.location.origin).href;
  const showContinueShoppingLink = isUpdateMessage && Boolean(icReferrer);

  return (
    <>
      {alertMessage?.alertStatus === 'error' ? (
        <Alert status={alertMessage?.alertStatus}>
          {alertMessage?.text && <Typography>{alertMessage.text}</Typography>}
        </Alert>
      ) : (
        <Alert
          status={alertMessage?.alertStatus}
          onClose={() => setAlertMessage(null)}
          data-testid="instant-checkout-alert-msg"
        >
          {alertMessage?.text && (
            <Typography>
              {alertMessage.text}
              {showContinueShoppingLink && (
                <Link
                  component="button"
                  onClick={setContinueShoppingAnalytics}
                  href={referrerUrl}
                >
                  Continue Shopping
                </Link>
              )}
            </Typography>
          )}
        </Alert>
      )}
    </>
  );
};
